class SearchSuggestionHelper {
  static formatResult = (suggestion, currentValue) => {
    return [
      `<div class='suggestion-class'>${this.svgArrow()}<span class='badge bg-primary'>${
        suggestion.class_name
      }</span></div>`,
      `<div class='suggestion-name'>${suggestion.description}</div>`,
    ].join("")
  }

  static svgArrow = () => {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.49 17.21" class="pe-2 arrow" width="20"><path d="m23.49 8.61a1.51 1.51 0 0 0 -.49-1.1l-7-7.06a1.55 1.55 0 0 0 -2.19 2.19l4.5 4.5h-16.76a1.55 1.55 0 0 0 0 3.1h16.57l-4.33 4.33a1.55 1.55 0 0 0 2.21 2.19l7.06-7s.05-.08.08-.12l.05-.06a1.51 1.51 0 0 0 .3-.97z"></path></svg>'
  }

  static noSuggestionNotice = () => {
    return `<div class='suggestion-no'>${i18next.t(
      "metasearchNoSuggestionNotice"
    )}</div>`
  }

  static suggestionSelected = (suggestion) => {
    const newUrl = `/metasearch/redirect?class_name=${suggestion.class_name}&id=${suggestion.data}`
    window.location = newUrl
  }

  static prepareResult = (element) => {
    let suggestionDescription, suggestionValue
    let description = element.description
    let className = element.class_name

    if (className == "Signature") {
      suggestionDescription = `${description.full_name} - <small class='text-muted'>${description.email}</small>`

      let phonesLine = [description.mobile, description.phone]
        .filter((obj) => obj)
        .join(" - ")

      suggestionDescription = [suggestionDescription, phonesLine]
        .filter((obj) => obj)
        .join("<br/>")

      suggestionValue = description.email
    } else if (className == "Organization") {
      const usersCount = i18next.t("userWithCount", {
        count: description.signatures_count,
      })
      suggestionDescription = `${description.name} <br/><small class='text-muted'>${usersCount}</small>`
      suggestionValue = suggestionDescription
    } else {
      suggestionDescription = description
      suggestionValue = suggestionDescription
    }

    return {
      value: suggestionValue,
      description: suggestionDescription,
      data: element.active_record_id,
      class_name: element.class_name,
    }
  }
}

export { SearchSuggestionHelper }
